module.exports = __webpack_public_path__ + "img/lincoln-logo.b3879a3b.jpg";